import React, { useState } from 'react';
import axios from 'axios';
import '../../App.css';

const Login = () => {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

const handleLogin = async (e) => {

  e.preventDefault();

  try {

    const response = await axios.post(
      "https://hmsapi.emedhatechnologies.com/master/api/login",
      credentials
    );

if (response.data.status === "Success") {

  localStorage.setItem(
    "user",
    JSON.stringify(response.data.user)
  );

  localStorage.setItem(
    "permissions",
    JSON.stringify(response.data.permissions)
  );

  window.location.href = "/dashboard";
}

  } catch (err) {

    setError(err.response?.data?.message || "Login Failed");

  }

};



  return (
    <div className="main-wrapper">
      <div className="glass-card">
        <div className="brand-header">
          <h1>Welcome Back</h1>
          <p>eMedha Hospital Management</p>
        </div>
        
        {error && <p style={{color: 'red', textAlign: 'center'}}>{error}</p>}

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Email Address</label>
            <input 
              type="email" 
              name="email" 
              placeholder="admin@hospital.com" 
              onChange={handleChange} 
              required 
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input 
              type="password" 
              name="password" 
              placeholder="••••••••" 
              onChange={handleChange} 
              required 
            />
          </div>
          <button type="submit" className="btn-luxury">Sign In</button>
          
          {/* <div style={{marginTop: '20px', textAlign: 'center'}}>
            <a href="/register" style={{color: '#8798ae', fontSize: '0.85rem', textDecoration: 'none'}}>
              Don't have an account? <span style={{color: '#11abea'}}>Register Hospital</span>
            </a>
          </div> */}
        </form>
      </div>
    </div>
  );
};

export default Login;